import { css, styled } from 'styles';
import { FormFieldError } from './FormField.styled';
import { StyledFormGroupProps } from './types';

const horizontalStyles = css`
  grid-gap: ${({ theme }) => theme.spacing.absolute.large};
  grid-template-columns: repeat(3, 1fr);

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const noErrorsStyles = css`
  ${FormFieldError} {
    display: none;
  }
`;

export const StyledFormGroup = styled.div<StyledFormGroupProps>`
  display: grid;
  grid-gap: ${({ theme }) => theme.spacing.absolute.smaller};

  ${({ $errors }) => !$errors && noErrorsStyles};
  ${({ $horizontal }) => $horizontal && horizontalStyles};

  & + & {
    margin-top: ${({ theme }) => theme.spacing.absolute.larger};
  }
`;

StyledFormGroup.displayName = 'FormGroup.Styled';
